import React from 'react'

const IconRss = ({ color = 'currentColor', ...rest }) => {
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            <g clipPath='url(#clip0_3305_4988)'>
                <path
                    d='M2.66602 7.3335C4.25731 7.3335 5.78344 7.96564 6.90866 9.09086C8.03387 10.2161 8.66602 11.7422 8.66602 13.3335'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M2.66602 2.6665C5.49499 2.6665 8.2081 3.79031 10.2085 5.7907C12.2089 7.79109 13.3327 10.5042 13.3327 13.3332'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M3.33268 13.3333C3.70087 13.3333 3.99935 13.0349 3.99935 12.6667C3.99935 12.2985 3.70087 12 3.33268 12C2.96449 12 2.66602 12.2985 2.66602 12.6667C2.66602 13.0349 2.96449 13.3333 3.33268 13.3333Z'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_3305_4988'>
                    <rect width='16' height='16' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default IconRss
